import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { LSOAcknowledgementNoticeComponent } from '../lsoacknowledgement-notice/lsoacknowledgement-notice.component';

@Component({
  selector: 'dl-lso-acknowledgement',
  templateUrl: './lso-acknowledgement.component.html',
  styleUrls: ['./lso-acknowledgement.component.scss']
})

export class LsoAcknowledgementComponent implements OnInit {

  public commentText = new FormControl('');
  public storedData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public ackData: any,
    public dialogRef: MatDialogRef<LsoAcknowledgementComponent>,
    public readonly noticeDialog: MatDialog,
    public _QnSbnDataService:QnSbnDataService,
  ) { }

  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
    })
  }

  sendAckDetails(){

    const noticeDialogRef = this.noticeDialog.open(LSOAcknowledgementNoticeComponent, {
      disableClose: true,
      panelClass: 'notice-ack-dialog'
    });
    noticeDialogRef.afterClosed().subscribe(res => {
      if (res=='false') {
        return;
      }
      else{
        let fileData = this._QnSbnDataService.fileUploadData(this.storedData);
        this.ackData = {
          ackComment: this.commentText.value,
          ackFile: fileData || [],
        }
        this.dialogRef.close(this.ackData);
      }
    }  );

    
  }
}
